import React, { useState } from "react";
import { Player } from "video-react";
import { useTranslation } from "react-i18next";
import { Accordion, Modal } from "react-bootstrap";

const Information = () => {
  const { t } = useTranslation();

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);

  return (
    <>
      <section className="information-section rain-information-section">
        <div className="first-para">
          <h2>
            {t("Dop-detail4")} <span></span>
          </h2>
          <p>
            {t('rt1')}
          </p>
          <p>
            {t('rt2')}
          </p>
        </div>
        <div className="first-para">
          <h2 className="smallhead">
           {t('rt3')} <span></span>
          </h2>
          <p>
            {t('rt4')}
          </p>
          <ol className="rain-list">
            {/* <li><span>Automated Prediction Markets:</span> RAIN is not an outcome market; it is a fully automated protocol enabling the creation and resolution of prediction markets without central authorities.</li> */}
            <li>
              <span>{t('rt5')}</span> {t('rt6')}
            </li>
            <li>
              <span>{t('rt7')}</span> {t('rt8')}
            </li>
            <li>
              <span>{t('rt9')}</span> {t('rt10')}
            </li>
            <li>
              <span>{t('rt11')}</span> {t('rt12')}
            </li>
            <li>
              <span>{t('rt13')}</span> {t('rt14')}
            </li>
            <li>
              <span>{t('rt15')}</span> {t('rt16')}
            </li>
          </ol>
        </div>
        <div className="first-para">
          <h2>
            {t('rt17')} <span></span>
          </h2>
          <ol className="rain-list">
            <li>
              <span>{t('rt18')}</span> {t('rt19')}
            </li>
            <li>
              <span>{t('rt20')}</span> {t('rt21')}
            </li>
            <li>
              <span>{t('rt22')}</span> {t('rt23')}
            </li>
            <li>
              <span>{t('rt24')}</span> {t('rt25')}
            </li>
          </ol>
        </div>
        <div className="first-para">
          <h2>
            {t('rt26')} <span></span>
          </h2>
          <h6 className="rainhead">{t('rt27')}</h6>
          <ol className="rain-list marginlist">
            <li>
              {t('rt28')}
            </li>
          </ol>
          <h6 className="rainhead">{t('rt29')}</h6>
          <ol className="rain-list marginlist">
            <li>
              {t('rt30')}
            </li>
            <li>
              {t('rt31')}
            </li>
          </ol>
          <h6 className="rainhead">{t('rt32')}</h6>
          <ol className="rain-list marginlist">
            <li>
              {t('rt33')}
            </li>
          </ol>
          <h6 className="rainhead">{t('rt34')}</h6>
          <ol className="rain-list listset">
            <li>
              {t('rt35')}
            </li>
          </ol>
        </div>
        <div className="first-para">
          <p>
            {t('rt36')}
          </p>
        </div>
        <div className="first-para">
          <h2>
            {t("Dop-detail31")} <span></span>
          </h2>
          <p>
            {t('rt37')}
          </p>
          <p>
            {t('rt38')}
          </p>
          {/* <div className="twice-tokenomics">
                        <div className="tokenomic-img" onClick={() => {setShow1(true)}} style={{cursor: "pointer"}}>
                            <img src="\assets\alldetailpages\rain\roadmap-light.png" alt="img" className='img-fluid d-none show-in-light-theme' />
                            <img src="\assets\alldetailpages\rain\raodmap-dark.png" alt="img" className='img-fluid hide-in-light-theme' />
                        </div>
                    </div> */}
        </div>
        <div className="first-para">
          <h3 className="lowerhead">
            {t('rt39')}<span></span>
          </h3>
          <p>{t('rt40')}</p>
          <ol className="rain-list listset">
            <li className="m-0">
              {t('rt41')}
            </li>
            <li className="m-0">
              {t('rt42')}
            </li>
          </ol>
        </div>
        <div className="first-para">
          <h3 className="lowerhead">
            {t('rt43')}<span></span>
          </h3>
          <p>
            {t('rt44')}
          </p>
          <ol className="rain-list listset">
            <li className="m-0">{t('rt45')}</li>
            <li className="m-0">
              {t('rt46')}
            </li>
            <li className="m-0">
              {t('rt47')}
            </li>
          </ol>
          <p>
            {t('rt48')}
          </p>
          <div className="twice-tokenomics">
            <Accordion defaultActiveKey="0" className="rainacc d-none">
                <div className="tophead">
                    <h6 className="firsthead">{t('rt49')}</h6>
                    <h6 className="lasthead">{t('rt50')}</h6>
                </div>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt51')}</h6>
                    <h6 className="lasthead">10%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt53')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt54')}</h6>
                    <h6 className="lasthead">10%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt55')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">Team</h6>
                    <h6 className="lasthead">10%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt64')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt56')}</h6>
                    <h6 className="lasthead">20%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt57')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt58')} </h6>
                    <h6 className="lasthead">15%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt59')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt60')}</h6>
                    <h6 className="lasthead">15%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt61')}</p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header className="bordernone">
                <div className="btnhead">
                    <h6 className="firsthead">{t('rt62')}</h6>
                    <h6 className="lasthead">20%</h6>
                </div>
                </Accordion.Header>
                <Accordion.Body className="bordertop">
                  <h6 className="bodyhead">{t('rt52')}</h6>
                  <p className="bodypara">{t('rt63')}</p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div
              className="tokenomic-img p-0 d-noneformbl"
              style={{ cursor: "pointer" }}
            >
              <img
                src="\assets\alldetailpages\rain\table-light.png"
                alt="img"
                className="img-fluid d-none show-in-light-theme"
              />
              <img
                src="\assets\alldetailpages\rain\table-dark.png"
                alt="img"
                className="img-fluid hide-in-light-theme"
              />
            </div>
            <div
              className="tokenomic-img d-noneformbl"
              onClick={() => {
                setShow1(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src="\assets\alldetailpages\rain\roadmap-light.png"
                alt="img"
                className="img-fluid d-none show-in-light-theme"
              />
              <img
                src="\assets\alldetailpages\rain\raodmap-dark.png"
                alt="img"
                className="img-fluid hide-in-light-theme"
              />
            </div>

            <div
              className="tokenomic-imgg d-blockformobile d-none w-100"
              onClick={() => {
                setShow1(true);
              }}
              style={{ cursor: "pointer" }}
            >
              <img
                src="\assets\alldetailpages\rain\roadmap-lightmbl.png"
                alt="img"
                className="img-fluid d-none show-in-light-theme w-100"
              />
              <img
                src="\assets\alldetailpages\rain\raodmap-darkmbl.png"
                alt="img"
                className="img-fluid hide-in-light-theme w-100"
              />
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="common-modal-style image-preview distribution-modl"
        show={show1}
        onHide={handleClose1}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <img
            src="\assets\alldetailpages\rain\roadmap-lightmbl.png"
            alt="img"
            className="img-fluid d-none show-in-light-theme w-100"
          />
          <img
            src="\assets\alldetailpages\rain\raodmap-darkmbl.png"
            alt="img"
            className="img-fluid hide-in-light-theme w-100"
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Information;
